module.exports = __webpack_public_path__ + "img/island-bridge-networks-500x500.87699805.png";